import LegalPage from "@/components/feature/LegalPage";

export default function PrivacyPolicy() {
  return (
    <LegalPage
      eyebrow="Privacy Policy"
      title="Privacy Policy"
      intro="This is a placeholder page outlining how Florida Family Clinic intends to handle information submitted through this website."
    >
      <h2 className="font-heading text-lg font-semibold text-foreground-950">Information we collect</h2>
      <p>
        When you use the inquiry form on this website, you may provide your name, email address,
        phone number, and a message. This information is used to respond to your inquiry about the
        clinic's services and availability.
      </p>

      <h2 className="font-heading text-lg font-semibold text-foreground-950">How information is used</h2>
      <p>
        Information submitted through this website is used only to respond to your request. Please
        do not submit sensitive medical information through the website contact form.
      </p>

      <h2 className="font-heading text-lg font-semibold text-foreground-950">Your choices</h2>
      <p>
        You may contact the clinic directly by phone or email at any time to ask questions about
        information you have submitted through the website.
      </p>

      <p className="text-sm text-foreground-500">
        This placeholder content is provided for informational purposes and should be replaced with
        a complete policy before publishing.
      </p>
    </LegalPage>
  );
}